import { lazy } from "react";
export const feature = {
    id: "tags",
    nav: [
        {
            id: "tags",
            label: "Tags",
            icon: "Tag",
            path: "/tags",
            group: "Platform",
            order: 9,
            actions: ["view", "create", "edit", "delete"],
            apiPaths: ["/tags", "/tags/*"],
        },
    ],
    routes: [
        {
            path: "/tags",
            component: lazy(() => import("./pages/Tags.js").then((m) => ({ default: m.Tags }))),
        },
        {
            path: "/tags/new",
            component: lazy(() => import("./pages/TagDetail.js").then((m) => ({ default: m.TagDetail }))),
        },
        {
            path: "/tags/:id",
            component: lazy(() => import("./pages/TagDetail.js").then((m) => ({ default: m.TagDetail }))),
        },
    ],
};
//# sourceMappingURL=index.js.map